import { render } from "./EmployeeList.vue?vue&type=template&id=98dc549c&ts=true"
import script from "./EmployeeList.vue?vue&type=script&lang=ts"
export * from "./EmployeeList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__